import { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";

import { withPortal } from "../GeneralServices/PortalService";
import withAlert from "../Alerts/withAlert";
import AuthenticationConfirmationForm from "./AuthenticationConfirmationForm";
import { getDisplayName } from "../Utils/getDisplayName";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../Alerts/Alert";

function withConfirmationForm(WrappedComponent) {
  class WithConfirmationForm extends Component {
    static displayName = `WithConfirmationForm(${getDisplayName(WrappedComponent)})`;

    constructor(props) {
      super(props);
      this.onAlertMessageClicked = this.onAlertMessageClicked.bind(this);
      this.onConfirmationSendClose = this.onConfirmationSendClose.bind(this);
      this.showConfirmationForm = this.showConfirmationForm.bind(this);
      this.hideConfirmationForm = this.hideConfirmationForm.bind(this);
    }

    get labels() {
      const { formatMessage } = this.props.intl;

      return {
        unconfirmedError: formatMessage(intlMessages.unconfirmedError, {
          a: message => `<a href="#resend-confirmation-instructions">${message}</a>`
        })
      };
    }

    onAlertMessageClicked(e) {
      if (e.target.href && e.target.href.match(/#resend-confirmation-instructions$/)) {
        e.preventDefault();
        e.stopPropagation();

        this.showConfirmationForm();
        this.props.hideAlert();
      } else if (this.props.onAlertMessageClicked) {
        // Allow chaining onAlertMessageClicked with other components
        this.props.onAlertMessageClicked(e);
      }
    }

    onConfirmationSendClose(success, message) {
      this.hideConfirmationForm();

      if (message) {
        this.props.showAlert({
          message,
          type: success ? ALERT_TYPE_SUCCESS : ALERT_TYPE_ERROR
        });
      }
    }

    showConfirmationForm(email = null) {
      this.portalIndex = this.props.showPortal(
        <AuthenticationConfirmationForm
          email={email}
          onClose={this.onConfirmationSendClose}
        />
      );
    }

    hideConfirmationForm() {
      if (this.portalIndex) {
        this.props.hidePortal(this.portalIndex);
        this.portalIndex = null;
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          key="wrapped-component"
          onAlertMessageClicked={this.onAlertMessageClicked}
          showConfirmationForm={this.showConfirmationForm}
          hideConfirmationForm={this.hideConfirmationForm}
          unconfirmedErrorMessage={this.labels.unconfirmedError}
        />
      );
    }
  }

  return withPortal(injectIntl(withAlert(WithConfirmationForm)));
}

export { withConfirmationForm };

const intlMessages = defineMessages({
  unconfirmedError: {
    id: "authentication.signIn.unconfirmedError",
    defaultMessage: `
      Impossible de vous connecter, vous devez confirmer votre compte afin
      de pouvoir vous connecter. Merci d'utiliser le lien de confirmation
      qui vous a été envoyé par mail, ou <a>demander un nouveau mail de confirmation</a>.
    `
  }
});
